import React from 'react';
import {Box} from "@material-ui/core";

export class LegendComponent extends React.Component {
	constructor(props) {
		super(props);
		const choices = props.choices.map(x => x.id);
		this.legendColumns = props.columns.filter(x => {
			return x.definition && x.name && x.selector && choices.includes(x.selector);
		});
  }
	render() {
		return (
			this.legendColumns && this.legendColumns.length>0 &&
			<Box style={{float: "right"}} textAlign="right" m={1} color="text.disabled" margin="30px" fontSize="small" border="solid 1px white" padding="20px" borderRadius="5px">
				<table>
					<th>Legend</th>
					{
						this.legendColumns.map(item => {
							if (!item.definition) return;
							return <tr><td>{item.name}</td><td align="left" style={{paddingLeft: '20px'}}>{item.definition}</td></tr>
						})
					}
				</table>
			</Box>
		)
	}
};